export default {
    "TABLE": {
        "COUNT": "Showing |{count} record| records from {from} to {to} ",
        "ACTIONS": "Actions",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/table.js